import localeText from '@/locales/datagrid'
import { SxProps, Theme } from '@mui/material'
import FilterModelPro, {
    GridFilterItemPro,
    GridFilterModelPro,
} from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import FilterPanelSelect from './PanelSelect'

export default function FieldColuna({
    columns = [],
    item,
    onFilterModelChange,
    sx,
}: {
    columns: GridColDefPro[]
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    sx?: SxProps<Theme>
}) {
    columns = columns.filter(f => f.filterable !== false)

    return (
        <FilterPanelSelect
            label={localeText.filterPanelColumn}
            options={columns.map(column => ({
                value: column.field,
                label: column.headerName,
            }))}
            value={item.columnField}
            sx={sx}
            onChange={e => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? (() => {
                                  const defaultOperatorForColumn =
                                      FilterModelPro.getDefaultOperator(
                                          columns.find(
                                              c => c.field === e.target.value,
                                          )?.type,
                                      )

                                  return {
                                      ...p,
                                      columnField: e.target.value as string,
                                      operatorValue:
                                          defaultOperatorForColumn ??
                                          p.operatorValue,
                                  }
                              })()
                            : p,
                    ),
                }))
            }}
        />
    )
}
